var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C1.34315 4 0 5.34315 0 7V13C0 14.6569 1.34315 16 3 16H17C18.6569 16 20 14.6569 20 13V7C20 5.34315 18.6569 4 17 4H3ZM6 11.25C6.69036 11.25 7.25 10.6904 7.25 10C7.25 9.30964 6.69036 8.75 6 8.75C5.30964 8.75 4.75 9.30964 4.75 10C4.75 10.6904 5.30964 11.25 6 11.25ZM11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10ZM14 11.25C14.6904 11.25 15.25 10.6904 15.25 10C15.25 9.30964 14.6904 8.75 14 8.75C13.3096 8.75 12.75 9.30964 12.75 10C12.75 10.6904 13.3096 11.25 14 11.25Z",
    fill: "#647FB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryButtonIcon);
export default __webpack_public_path__ + "static/media/primary-button-icon.1035a2aed27852e8ff791b9418a677d7.svg";
export { ForwardRef as ReactComponent };